import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { Button, ClickAwayListener, Grow, lighten, ListItemText, MenuItem, MenuList, Paper, Popper, Typography } from '@mui/material'

export type proptypes = {
  type: 'time' | 'batch';
  setType: any;
}
export const defaultProps: proptypes = {
  type: 'batch',
  setType: () => {}
}

const StyledPopper = styled(Popper)`
  z-index: 9999;
  .Mui-selected{
    background-color: ${p => p.theme.palette.lightGrey[60]}
  }
  .Mui-selected:hover{
    background-color: ${p => p.theme.palette.lightGrey.main}
  }
  .clear-selection {
    padding: 8px 18px;
    background-color: ${p => lighten(p.theme.palette.lightGrey[50], 0.3)};
  }
  .timezone-search {
    width: 100%;
    padding: 4px 0;
    font-size: 14px;
    background-color: ${p => lighten(p.theme.palette.lightGrey[50], 0.3)};
    &:after, &:hover:before {
      border-bottom: 1px solid black;
    }
  }
`

const _TypeSelector: React.FC<proptypes & { className?: string }> = (props) => {
  const { className, type, setType } = props
  const [open, setOpen] = useState<boolean>(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const types: { name: string, type: 'batch' | 'time'}[] = [
    {
      name: 'Batch',
      type: 'batch'
    },
    {
      name: 'Time',
      type: 'time'
    }
  ]

  const onChangeHandler = (val: { name: string, type: 'batch' | 'time'}) => {
    if (val.type === type) return
    setType(val.type)
    setOpen(false)
  }

return <div className={className}>
    <Typography style={{ fontSize: 13, margin: '14px 0 2px 0' }}>Scheduler Type*</Typography>
    <Button
      className='type-button'
      id='type-button'
      data-cy='type-button'
      ref={anchorRef}
      color='secondary'
      variant='outlined'
      size='large'
      onClick={() => setOpen(!open)}
      endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
    >
      {type ? type : 'Select DDW Schedule Type'}
    </Button>
    <StyledPopper
      open={open}
      anchorEl={anchorRef.current}
      placement='bottom-start'
      style={{ minWidth: anchorRef.current?.offsetWidth || '100%' }}
      transition
    >
      {({ TransitionProps }) => <Grow {...TransitionProps} timeout={200}>
        <Paper sx={{ bgcolor: 'white' }}>
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div>
              <MenuList id='type-menu' style={{ maxHeight: 300, overflowY: 'auto', paddingTop: 0, paddingBottom: 0 }} autoFocusItem={open} variant='selectedMenu'>
                {types.map((t, i) => <MenuItem key={i} value={t.type} onClick={() => onChangeHandler(t)} selected={type === t.type}>
                    <ListItemText primaryTypographyProps={{ fontSize: '13px', textTransform: 'capitalize' }} primary={t.name} />
                  </MenuItem>
                )}
              </MenuList>
            </div>
          </ClickAwayListener>
        </Paper>
      </Grow>}
    </StyledPopper>
  </div>
}

export const TypeSelectorComponent = styled(_TypeSelector)`
  margin-bottom: 16px;
  .type-button {
    text-transform: capitalize;
    font-size: 14px;
    padding: 4px 12px 4px 14px;
  }
`
export default TypeSelectorComponent